import cities from '../data/cities'

export default function getCitySlugByName(cityName: string | null | undefined) {
  const city = cities.find(city => city.value === cityName)
  return city?.slug ?? ''
}
